import { render, staticRenderFns } from "./CustomerUpdateForm.vue?vue&type=template&id=0997ff4a&"
import script from "./CustomerUpdateForm.vue?vue&type=script&lang=js&"
export * from "./CustomerUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0997ff4a')) {
      api.createRecord('0997ff4a', component.options)
    } else {
      api.reload('0997ff4a', component.options)
    }
    module.hot.accept("./CustomerUpdateForm.vue?vue&type=template&id=0997ff4a&", function () {
      api.rerender('0997ff4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerUpdateForm.vue"
export default component.exports